module.exports = __webpack_public_path__ + "media/man2.df65a45b.wav";